
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
:host {
  box-sizing: border-box;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--grid-gutter-x) * 0.5);
  padding-left: calc(var(--grid-gutter-x) * 0.5);
  margin-top: var(--grid-gutter-y);
  flex: 1 0 0%;
}
:host slot.grid-col-wrapper {
  width: 100%;
}

:host([cols=auto]) {
  flex: 0 0 auto;
  width: auto;
}

:host([cols="1"]) {
  flex: 0 0 auto;
  width: 8.3333333333%;
}

:host([offset="1"]) {
  margin-left: 8.3333333333%;
}

:host([cols="2"]) {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

:host([offset="2"]) {
  margin-left: 16.6666666667%;
}

:host([cols="3"]) {
  flex: 0 0 auto;
  width: 25%;
}

:host([offset="3"]) {
  margin-left: 25%;
}

:host([cols="4"]) {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

:host([offset="4"]) {
  margin-left: 33.3333333333%;
}

:host([cols="5"]) {
  flex: 0 0 auto;
  width: 41.6666666667%;
}

:host([offset="5"]) {
  margin-left: 41.6666666667%;
}

:host([cols="6"]) {
  flex: 0 0 auto;
  width: 50%;
}

:host([offset="6"]) {
  margin-left: 50%;
}

:host([cols="7"]) {
  flex: 0 0 auto;
  width: 58.3333333333%;
}

:host([offset="7"]) {
  margin-left: 58.3333333333%;
}

:host([cols="8"]) {
  flex: 0 0 auto;
  width: 66.6666666667%;
}

:host([offset="8"]) {
  margin-left: 66.6666666667%;
}

:host([cols="9"]) {
  flex: 0 0 auto;
  width: 75%;
}

:host([offset="9"]) {
  margin-left: 75%;
}

:host([cols="10"]) {
  flex: 0 0 auto;
  width: 83.3333333333%;
}

:host([offset="10"]) {
  margin-left: 83.3333333333%;
}

:host([cols="11"]) {
  flex: 0 0 auto;
  width: 91.6666666667%;
}

:host([offset="11"]) {
  margin-left: 91.6666666667%;
}

:host([cols="12"]) {
  flex: 0 0 auto;
  width: 100%;
}

:host([offset="12"]) {
  margin-left: 100%;
}

:host([order=first]) {
  order: -1 !important;
}

:host([order="0"]) {
  order: 0 !important;
}

:host([order="1"]) {
  order: 1 !important;
}

:host([order="2"]) {
  order: 2 !important;
}

:host([order="3"]) {
  order: 3 !important;
}

:host([order="4"]) {
  order: 4 !important;
}

:host([order="5"]) {
  order: 5 !important;
}

:host([order=last]) {
  order: 6 !important;
}

:host([align-self=auto]) {
  align-self: auto !important;
}

:host([align-self=start]) {
  align-self: flex-start !important;
}

:host([align-self=end]) {
  align-self: flex-end !important;
}

:host([align-self=center]) {
  align-self: center !important;
}

:host([align-self=baseline]) {
  align-self: baseline !important;
}

:host([align-self=stretch]) {
  align-self: stretch !important;
}

@media (min-width: 560px) {
  :host([cols-sm=auto]) {
    flex: 0 0 auto;
    width: auto;
  }
  :host([cols-sm="1"]) {
    flex: 0 0 auto;
    width: 8.3333333333%;
  }
  :host([offset-sm="1"]) {
    margin-left: 8.3333333333%;
  }
  :host([cols-sm="2"]) {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  :host([offset-sm="2"]) {
    margin-left: 16.6666666667%;
  }
  :host([cols-sm="3"]) {
    flex: 0 0 auto;
    width: 25%;
  }
  :host([offset-sm="3"]) {
    margin-left: 25%;
  }
  :host([cols-sm="4"]) {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  :host([offset-sm="4"]) {
    margin-left: 33.3333333333%;
  }
  :host([cols-sm="5"]) {
    flex: 0 0 auto;
    width: 41.6666666667%;
  }
  :host([offset-sm="5"]) {
    margin-left: 41.6666666667%;
  }
  :host([cols-sm="6"]) {
    flex: 0 0 auto;
    width: 50%;
  }
  :host([offset-sm="6"]) {
    margin-left: 50%;
  }
  :host([cols-sm="7"]) {
    flex: 0 0 auto;
    width: 58.3333333333%;
  }
  :host([offset-sm="7"]) {
    margin-left: 58.3333333333%;
  }
  :host([cols-sm="8"]) {
    flex: 0 0 auto;
    width: 66.6666666667%;
  }
  :host([offset-sm="8"]) {
    margin-left: 66.6666666667%;
  }
  :host([cols-sm="9"]) {
    flex: 0 0 auto;
    width: 75%;
  }
  :host([offset-sm="9"]) {
    margin-left: 75%;
  }
  :host([cols-sm="10"]) {
    flex: 0 0 auto;
    width: 83.3333333333%;
  }
  :host([offset-sm="10"]) {
    margin-left: 83.3333333333%;
  }
  :host([cols-sm="11"]) {
    flex: 0 0 auto;
    width: 91.6666666667%;
  }
  :host([offset-sm="11"]) {
    margin-left: 91.6666666667%;
  }
  :host([cols-sm="12"]) {
    flex: 0 0 auto;
    width: 100%;
  }
  :host([offset-sm="12"]) {
    margin-left: 100%;
  }
  :host([order-sm=first]) {
    order: -1 !important;
  }
  :host([order-sm="0"]) {
    order: 0 !important;
  }
  :host([order-sm="1"]) {
    order: 1 !important;
  }
  :host([order-sm="2"]) {
    order: 2 !important;
  }
  :host([order-sm="3"]) {
    order: 3 !important;
  }
  :host([order-sm="4"]) {
    order: 4 !important;
  }
  :host([order-sm="5"]) {
    order: 5 !important;
  }
  :host([order-sm=last]) {
    order: 6 !important;
  }
  :host([align-self-sm=auto]) {
    align-self: auto !important;
  }
  :host([align-self-sm=start]) {
    align-self: flex-start !important;
  }
  :host([align-self-sm=end]) {
    align-self: flex-end !important;
  }
  :host([align-self-sm=center]) {
    align-self: center !important;
  }
  :host([align-self-sm=baseline]) {
    align-self: baseline !important;
  }
  :host([align-self-sm=stretch]) {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  :host([cols-md=auto]) {
    flex: 0 0 auto;
    width: auto;
  }
  :host([cols-md="1"]) {
    flex: 0 0 auto;
    width: 8.3333333333%;
  }
  :host([offset-md="1"]) {
    margin-left: 8.3333333333%;
  }
  :host([cols-md="2"]) {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  :host([offset-md="2"]) {
    margin-left: 16.6666666667%;
  }
  :host([cols-md="3"]) {
    flex: 0 0 auto;
    width: 25%;
  }
  :host([offset-md="3"]) {
    margin-left: 25%;
  }
  :host([cols-md="4"]) {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  :host([offset-md="4"]) {
    margin-left: 33.3333333333%;
  }
  :host([cols-md="5"]) {
    flex: 0 0 auto;
    width: 41.6666666667%;
  }
  :host([offset-md="5"]) {
    margin-left: 41.6666666667%;
  }
  :host([cols-md="6"]) {
    flex: 0 0 auto;
    width: 50%;
  }
  :host([offset-md="6"]) {
    margin-left: 50%;
  }
  :host([cols-md="7"]) {
    flex: 0 0 auto;
    width: 58.3333333333%;
  }
  :host([offset-md="7"]) {
    margin-left: 58.3333333333%;
  }
  :host([cols-md="8"]) {
    flex: 0 0 auto;
    width: 66.6666666667%;
  }
  :host([offset-md="8"]) {
    margin-left: 66.6666666667%;
  }
  :host([cols-md="9"]) {
    flex: 0 0 auto;
    width: 75%;
  }
  :host([offset-md="9"]) {
    margin-left: 75%;
  }
  :host([cols-md="10"]) {
    flex: 0 0 auto;
    width: 83.3333333333%;
  }
  :host([offset-md="10"]) {
    margin-left: 83.3333333333%;
  }
  :host([cols-md="11"]) {
    flex: 0 0 auto;
    width: 91.6666666667%;
  }
  :host([offset-md="11"]) {
    margin-left: 91.6666666667%;
  }
  :host([cols-md="12"]) {
    flex: 0 0 auto;
    width: 100%;
  }
  :host([offset-md="12"]) {
    margin-left: 100%;
  }
  :host([order-md=first]) {
    order: -1 !important;
  }
  :host([order-md="0"]) {
    order: 0 !important;
  }
  :host([order-md="1"]) {
    order: 1 !important;
  }
  :host([order-md="2"]) {
    order: 2 !important;
  }
  :host([order-md="3"]) {
    order: 3 !important;
  }
  :host([order-md="4"]) {
    order: 4 !important;
  }
  :host([order-md="5"]) {
    order: 5 !important;
  }
  :host([order-md=last]) {
    order: 6 !important;
  }
  :host([align-self-md=auto]) {
    align-self: auto !important;
  }
  :host([align-self-md=start]) {
    align-self: flex-start !important;
  }
  :host([align-self-md=end]) {
    align-self: flex-end !important;
  }
  :host([align-self-md=center]) {
    align-self: center !important;
  }
  :host([align-self-md=baseline]) {
    align-self: baseline !important;
  }
  :host([align-self-md=stretch]) {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  :host([cols-lg=auto]) {
    flex: 0 0 auto;
    width: auto;
  }
  :host([cols-lg="1"]) {
    flex: 0 0 auto;
    width: 8.3333333333%;
  }
  :host([offset-lg="1"]) {
    margin-left: 8.3333333333%;
  }
  :host([cols-lg="2"]) {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  :host([offset-lg="2"]) {
    margin-left: 16.6666666667%;
  }
  :host([cols-lg="3"]) {
    flex: 0 0 auto;
    width: 25%;
  }
  :host([offset-lg="3"]) {
    margin-left: 25%;
  }
  :host([cols-lg="4"]) {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  :host([offset-lg="4"]) {
    margin-left: 33.3333333333%;
  }
  :host([cols-lg="5"]) {
    flex: 0 0 auto;
    width: 41.6666666667%;
  }
  :host([offset-lg="5"]) {
    margin-left: 41.6666666667%;
  }
  :host([cols-lg="6"]) {
    flex: 0 0 auto;
    width: 50%;
  }
  :host([offset-lg="6"]) {
    margin-left: 50%;
  }
  :host([cols-lg="7"]) {
    flex: 0 0 auto;
    width: 58.3333333333%;
  }
  :host([offset-lg="7"]) {
    margin-left: 58.3333333333%;
  }
  :host([cols-lg="8"]) {
    flex: 0 0 auto;
    width: 66.6666666667%;
  }
  :host([offset-lg="8"]) {
    margin-left: 66.6666666667%;
  }
  :host([cols-lg="9"]) {
    flex: 0 0 auto;
    width: 75%;
  }
  :host([offset-lg="9"]) {
    margin-left: 75%;
  }
  :host([cols-lg="10"]) {
    flex: 0 0 auto;
    width: 83.3333333333%;
  }
  :host([offset-lg="10"]) {
    margin-left: 83.3333333333%;
  }
  :host([cols-lg="11"]) {
    flex: 0 0 auto;
    width: 91.6666666667%;
  }
  :host([offset-lg="11"]) {
    margin-left: 91.6666666667%;
  }
  :host([cols-lg="12"]) {
    flex: 0 0 auto;
    width: 100%;
  }
  :host([offset-lg="12"]) {
    margin-left: 100%;
  }
  :host([order-lg=first]) {
    order: -1 !important;
  }
  :host([order-lg="0"]) {
    order: 0 !important;
  }
  :host([order-lg="1"]) {
    order: 1 !important;
  }
  :host([order-lg="2"]) {
    order: 2 !important;
  }
  :host([order-lg="3"]) {
    order: 3 !important;
  }
  :host([order-lg="4"]) {
    order: 4 !important;
  }
  :host([order-lg="5"]) {
    order: 5 !important;
  }
  :host([order-lg=last]) {
    order: 6 !important;
  }
  :host([align-self-lg=auto]) {
    align-self: auto !important;
  }
  :host([align-self-lg=start]) {
    align-self: flex-start !important;
  }
  :host([align-self-lg=end]) {
    align-self: flex-end !important;
  }
  :host([align-self-lg=center]) {
    align-self: center !important;
  }
  :host([align-self-lg=baseline]) {
    align-self: baseline !important;
  }
  :host([align-self-lg=stretch]) {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  :host([cols-xl=auto]) {
    flex: 0 0 auto;
    width: auto;
  }
  :host([cols-xl="1"]) {
    flex: 0 0 auto;
    width: 8.3333333333%;
  }
  :host([offset-xl="1"]) {
    margin-left: 8.3333333333%;
  }
  :host([cols-xl="2"]) {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  :host([offset-xl="2"]) {
    margin-left: 16.6666666667%;
  }
  :host([cols-xl="3"]) {
    flex: 0 0 auto;
    width: 25%;
  }
  :host([offset-xl="3"]) {
    margin-left: 25%;
  }
  :host([cols-xl="4"]) {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  :host([offset-xl="4"]) {
    margin-left: 33.3333333333%;
  }
  :host([cols-xl="5"]) {
    flex: 0 0 auto;
    width: 41.6666666667%;
  }
  :host([offset-xl="5"]) {
    margin-left: 41.6666666667%;
  }
  :host([cols-xl="6"]) {
    flex: 0 0 auto;
    width: 50%;
  }
  :host([offset-xl="6"]) {
    margin-left: 50%;
  }
  :host([cols-xl="7"]) {
    flex: 0 0 auto;
    width: 58.3333333333%;
  }
  :host([offset-xl="7"]) {
    margin-left: 58.3333333333%;
  }
  :host([cols-xl="8"]) {
    flex: 0 0 auto;
    width: 66.6666666667%;
  }
  :host([offset-xl="8"]) {
    margin-left: 66.6666666667%;
  }
  :host([cols-xl="9"]) {
    flex: 0 0 auto;
    width: 75%;
  }
  :host([offset-xl="9"]) {
    margin-left: 75%;
  }
  :host([cols-xl="10"]) {
    flex: 0 0 auto;
    width: 83.3333333333%;
  }
  :host([offset-xl="10"]) {
    margin-left: 83.3333333333%;
  }
  :host([cols-xl="11"]) {
    flex: 0 0 auto;
    width: 91.6666666667%;
  }
  :host([offset-xl="11"]) {
    margin-left: 91.6666666667%;
  }
  :host([cols-xl="12"]) {
    flex: 0 0 auto;
    width: 100%;
  }
  :host([offset-xl="12"]) {
    margin-left: 100%;
  }
  :host([order-xl=first]) {
    order: -1 !important;
  }
  :host([order-xl="0"]) {
    order: 0 !important;
  }
  :host([order-xl="1"]) {
    order: 1 !important;
  }
  :host([order-xl="2"]) {
    order: 2 !important;
  }
  :host([order-xl="3"]) {
    order: 3 !important;
  }
  :host([order-xl="4"]) {
    order: 4 !important;
  }
  :host([order-xl="5"]) {
    order: 5 !important;
  }
  :host([order-xl=last]) {
    order: 6 !important;
  }
  :host([align-self-xl=auto]) {
    align-self: auto !important;
  }
  :host([align-self-xl=start]) {
    align-self: flex-start !important;
  }
  :host([align-self-xl=end]) {
    align-self: flex-end !important;
  }
  :host([align-self-xl=center]) {
    align-self: center !important;
  }
  :host([align-self-xl=baseline]) {
    align-self: baseline !important;
  }
  :host([align-self-xl=stretch]) {
    align-self: stretch !important;
  }
}
@media (min-width: 1400px) {
  :host([cols-xxl=auto]) {
    flex: 0 0 auto;
    width: auto;
  }
  :host([cols-xxl="1"]) {
    flex: 0 0 auto;
    width: 8.3333333333%;
  }
  :host([offset-xxl="1"]) {
    margin-left: 8.3333333333%;
  }
  :host([cols-xxl="2"]) {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  :host([offset-xxl="2"]) {
    margin-left: 16.6666666667%;
  }
  :host([cols-xxl="3"]) {
    flex: 0 0 auto;
    width: 25%;
  }
  :host([offset-xxl="3"]) {
    margin-left: 25%;
  }
  :host([cols-xxl="4"]) {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  :host([offset-xxl="4"]) {
    margin-left: 33.3333333333%;
  }
  :host([cols-xxl="5"]) {
    flex: 0 0 auto;
    width: 41.6666666667%;
  }
  :host([offset-xxl="5"]) {
    margin-left: 41.6666666667%;
  }
  :host([cols-xxl="6"]) {
    flex: 0 0 auto;
    width: 50%;
  }
  :host([offset-xxl="6"]) {
    margin-left: 50%;
  }
  :host([cols-xxl="7"]) {
    flex: 0 0 auto;
    width: 58.3333333333%;
  }
  :host([offset-xxl="7"]) {
    margin-left: 58.3333333333%;
  }
  :host([cols-xxl="8"]) {
    flex: 0 0 auto;
    width: 66.6666666667%;
  }
  :host([offset-xxl="8"]) {
    margin-left: 66.6666666667%;
  }
  :host([cols-xxl="9"]) {
    flex: 0 0 auto;
    width: 75%;
  }
  :host([offset-xxl="9"]) {
    margin-left: 75%;
  }
  :host([cols-xxl="10"]) {
    flex: 0 0 auto;
    width: 83.3333333333%;
  }
  :host([offset-xxl="10"]) {
    margin-left: 83.3333333333%;
  }
  :host([cols-xxl="11"]) {
    flex: 0 0 auto;
    width: 91.6666666667%;
  }
  :host([offset-xxl="11"]) {
    margin-left: 91.6666666667%;
  }
  :host([cols-xxl="12"]) {
    flex: 0 0 auto;
    width: 100%;
  }
  :host([offset-xxl="12"]) {
    margin-left: 100%;
  }
  :host([order-xxl=first]) {
    order: -1 !important;
  }
  :host([order-xxl="0"]) {
    order: 0 !important;
  }
  :host([order-xxl="1"]) {
    order: 1 !important;
  }
  :host([order-xxl="2"]) {
    order: 2 !important;
  }
  :host([order-xxl="3"]) {
    order: 3 !important;
  }
  :host([order-xxl="4"]) {
    order: 4 !important;
  }
  :host([order-xxl="5"]) {
    order: 5 !important;
  }
  :host([order-xxl=last]) {
    order: 6 !important;
  }
  :host([align-self-xxl=auto]) {
    align-self: auto !important;
  }
  :host([align-self-xxl=start]) {
    align-self: flex-start !important;
  }
  :host([align-self-xxl=end]) {
    align-self: flex-end !important;
  }
  :host([align-self-xxl=center]) {
    align-self: center !important;
  }
  :host([align-self-xxl=baseline]) {
    align-self: baseline !important;
  }
  :host([align-self-xxl=stretch]) {
    align-self: stretch !important;
  }
}
`;
